export const header = {
    dictionary: "과목사전",
    timetable: "모의시간표",
    planner: "졸업플래너",
    writeReviews: "과목후기 작성하기",
    syllabus: "실라버스",
    changeTheme: "테마 변경",
    openMenu: "메뉴 열기",
    navigationMenu: "주요 메뉴",
}
